import React from 'react';
import styled from '@emotion/styled';
import { IEntity } from 'types/company';
import Avatar from 'ui/elements/avatars/Avatar';
import CompanyLogo from 'ui/elements/CompanyLogo';
import { bluePlanetTheme } from 'ui/theme';

const DEFAULT_SIZE = 32;

const Container = styled.span<{ size: number }>`
  position: relative;
  display: inline-flex;
  flex-shrink: 0;
  width: ${props => props.size}px;
  height: ${props => props.size}px;
`;

/* Sits on the corner of the logo. The ring keeps it legible against whatever is behind it. */
const Badge = styled.span`
  position: absolute;
  right: 0;
  bottom: 0;
  display: flex;
  border-radius: 50%;
  border: 2px solid ${bluePlanetTheme.bluePlanetPalette.white};
  background-color: ${bluePlanetTheme.bluePlanetPalette.white};
`;

interface Props {
  company?: IEntity;
  user?: { name?: string; imageUrl?: string };
  size?: number;
  className?: string;
}

/**
 * Who something is written as: a company or community's logo with the person behind it badged onto
 * the corner. Without a company it is just the person, so callers who sometimes act as themselves
 * don't have to branch.
 */
export default function CompanyUserAvatar({ company, user, size = DEFAULT_SIZE, className }: Props) {
  if (!company) {
    return <Avatar className={className} size={size} imageUrl={user?.imageUrl} userName={user?.name} />;
  }

  return (
    <Container className={className} size={size}>
      <CompanyLogo company={company} size={size} />
      <Badge>
        <Avatar size={Math.round(size / 2)} imageUrl={user?.imageUrl} userName={user?.name} />
      </Badge>
    </Container>
  );
}
